<template>
  <div class="card form-sign-in">
    <div class="card-body text-center" v-if="loading === true">
      <loading/>
      <span class="d-block mt-2">{{t('Loading')}}</span>
    </div>
    <div>
      <div class="card-header">{{t('Security PIN recovery')}}</div>
      <div class="card-body">
        <div class="page-expired" v-if="pageExpired">
          <div class="text-danger">
            {{ t('Page validity expired') }} .
          </div>
          <button @click="backToLogin" class="btn btn-primary continue-btn">{{t('Back to login page')}}</button>
        </div>
        <div class="recovery-progress" v-if="searching">
          <div class="info"
               v-html="t('We are recovering your security PIN. This may take a few minutes. Please do not close your browser.')"></div>
          <div class="progress">
            <div class="progress-bar progress-bar-striped" role="progressbar" :style="'width:' + progressVal + '%'"
                 :aria-valuenow="this.progressVal" aria-valuemin="0" aria-valuemax="100">{{progressVal}} %
            </div>
          </div>
        </div>
        <div class="recovery-result-success" v-if="!searching && foundPinValue !== null">
          <div>{{t('Your security PIN is')}}:</div>
          <div class="h1 text-success">{{foundPinValue}}</div>
          <div class="info">{{t('Please remember this code or take a photo with your cellphone and save it. You may need it in the future when signing into Mendel.')}}</div>
          <div class="info">{{t('Do not share this code with other persons under no circumstances.')}}</div>
          <button @click="setPinAndContinue" class="btn btn-primary continue-btn">{{t('Continue to application')}}
          </button>
        </div>
        <div class="recovery-result-failure" v-if="!pageExpired && !searching && foundPinValue === null">
          <div class="fail-text text-danger">
            {{ t('We could not automatically recover your security PIN. Please contact us at the following e-mail address:') }}
          </div>
          <div class="email"><a @click="logContactClick" href="mailto:it@ceeor.com">{{contactEmail}}</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Loading from '../../core/Components/loading'
    import CryptoJS from 'crypto-js'

    export default {
        name: 'RecoverPin',
        components: {
            Loading
        },
        computed: {},
        data() {
            return {
                loading: true,
                hash: null,
                foundPinValue: null,
                searching: false,
                progressVal: 0,
                pageExpired: false,
                contactEmail: 'it@ceeor.com'
            }
        },
        methods: {
            logContactClick() {
                this.$store.dispatch('log/log',{
                    'name':'user.pinRcvrClickedContact',
                    'context':this.contactEmail
                });
            },
            backToLogin() {
                this.$router.push({name: 'login'});
            },
            setPinAndContinue() {
                this.$store.dispatch('log/log',{
                    'name':'user.pinRcvrClickedContinueToApp'
                });
                this.getUserStore().getLoggedUser().set('securityPin', this.foundPinValue);
                this.$router.push({name: 'dashboard'})
            },
            runRecovery() {
                this.hash = this.$route.params.recoveryHash;
                this.loading = false;
                this.searching = true;
                let pin = null;
                let numIt = 1000000;
                let batchSize = 40000;
                // let numIt = 100;
                // let batchSize = 10;
                let batches = [];
                let pinMap = {};
                let i = 0;
                let numBatches = Math.ceil(numIt / batchSize);
                for (let bn = 0; bn < numBatches; bn++) {
                    batches.push(bn);
                }
                this.$store.dispatch('account/getPinHint').then(hint => {
                    const loadBatch = batchNum => {
                        let b = 0;
                        let batch = [];
                        while (i < numIt && b < batchSize) {
                            let iPadded = i.toString().padStart(6, '0');
                            pin = CryptoJS.SHA512(CryptoJS.enc.Utf8.parse(iPadded)).toString();
                            if(pin.substring(0,2) === hint) {
                                batch.push(pin);
                                pinMap[pin] = iPadded;
                            }
                            b++;
                            i++;
                        }
                        return batch;
                    }
                    let foundHash = null;
                    let that = this;
                    const verifyPinBatch = (batch, index) => {
                        return that.$store.dispatch('account/verifyPinBatch', {
                            'hash': that.hash,
                            'batch': batch
                        }).then(response => {
                            if (response.data.status === true && response.data.foundHash !== null) {
                                foundHash = response.data.foundHash;
                            } else if (response.data.status === false) {
                                this.pageExpired = true;
                                this.searching = false;
                            }
                            this.progressVal = Math.ceil((index + 1) / numBatches * 100);
                        });
                    }
                    batches.reduce((acc, curr) => {
                        return acc.then(res => {
                            let batch = loadBatch(curr);
                            return verifyPinBatch(batch, curr).then(resp => {
                                return [...res, resp];
                            });
                        });
                    }, Promise.resolve([])).then(res => {
                        if (foundHash !== null) {
                            if (pinMap.hasOwnProperty(foundHash)) {
                                this.foundPinValue = pinMap[foundHash];
                            }
                        }
                        //this.foundPinValue = '999999';
                        this.$store.dispatch('log/log', {
                            'name': this.foundPinValue !== null ? 'user.pinRcvrSuccess' : 'user.pinRcvrFailed'
                        });
                        this.searching = false;
                        return true;
                    });


                });
            }
        },
        mounted() {
            if (!this.getUserStore().getLoggedUser().getSecurityPin()) {
                this.$store.dispatch('log/log', {
                    'name': 'user.pinRcvrLinkClicked',
                    'context': window.location.href
                });
                this.runRecovery();
            } else {
                this.$router.push({name: 'dashboard'})
            }

        }
    }
</script>

<style lang="scss">
  .recovery-progress {
    .progress {
      margin: 1.5rem;
    }
  }

  .recovery-result-success {
    text-align: center;

    .continue-btn {
      margin: 1.5rem;
    }

    div {
      margin-bottom: 0.5rem;
    }
  }

  .recovery-result-failure {
    text-align: center;

    .fail-text {
      margin: 1.0rem;
    }

    .email {
      margin-bottom: 1.5rem;
      font-size: 1.2rem;
    }
  }

  .page-expired {
    text-align: center;

    .continue-btn {
      margin: 1.5rem;
    }
  }
  .info {
    display: block;
    font-size: 1em;
    color: gray;
    padding-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/private/RecoverPin.vue